import { mapGetters } from 'vuex';
import Product from 'aa/vue/models/Product';
import Domain from 'helpers/Domain';
import { ACTION_NAMES, PAGE_TYPES } from 'aa/vue/constants/aaTrackingConstants';
import { tracking } from 'services/Tracking';
import { FTC_COMPLIANCE_CHECKBOX_ENABLED } from 'aa/helpers/featureConstants';

export default {
    data() {
        return {
            isPaymentPage: true,
            isUserOriginalPlanTypeMonthly: true,
            featureAsterisk: false,
        };
    },
    //mixins: [NotificationMixin, modalMixin, syncdataMixin],
    computed: {
        ...mapGetters({
            upgradeAnnualToggle: 'featureFlags/upgradeAnnualToggle',
            selectedPlan: 'plan/selectedPlan',
            monthlySelectedAndAnnualAvailable: 'plan/monthlySelectedAndAnnualAvailable',
            annualSelectedAndMonthlyAvailable: 'plan/annualSelectedAndMonthlyAvailable',
        }),
        isUpgradeAnnualToggle() {
            return (
                this.upgradeAnnualToggle &&
                !this.isSinglePlanRegion &&
                this.isUserOriginalPlanTypeMonthly &&
                (this.canToggleFromMonthlyToAnnual || this.canToggleFromAnnualToMonthly)
            );
        },
        isSinglePlanRegion() {
            if (Domain.isDomestic()) {
                return false;
            } else if (Domain.getRegionCode() === 'de') {
                return true;
            }
            return false;
        },
        userPlan() {
            return !this.$store.getters.getServerDataByKey('multiSubPlanPicker')
                ? this.currentPlan
                : this.selectedPlan;
        },
        canToggleFromMonthlyToAnnual() {
            // domestic uses currentPlan here while int'l populates selectedPlan
            return (
                this.userPlan?.planType === Product.TYPE_MONTHLY &&
                this.monthlySelectedAndAnnualAvailable.length > 0
            );
        },
        canToggleFromAnnualToMonthly() {
            return (
                this.userPlan?.planType === Product.TYPE_ANNUAL &&
                this.annualSelectedAndMonthlyAvailable.length > 0
            );
        },
        showFTCCheckbox() {
            return !!this.$store.getters.featureIsActive(FTC_COMPLIANCE_CHECKBOX_ENABLED);
        },
    },
    methods: {
        /**
         * Get the switch state value from local storage.
         *
         * @returns {boolean}
         */
        togglePlanType(switchToAnnual) {
            const getterKey = switchToAnnual
                ? 'monthlySelectedAndAnnualAvailable'
                : 'annualSelectedAndMonthlyAvailable';
            const newPlan = this.$store.getters[`plan/${getterKey}`];
            const planToSwitchTo = newPlan?.length ? newPlan[0] : null;

            if (!planToSwitchTo) {
                return;
            }

            if (this.showFTCCheckbox) {
                // Set the cooling rights waived state to false only if the checkbox flag is true to avoid breaking payments
                this.$store.commit('ftc/setCoolingRightsWaived', false);
            }

            this.$store.dispatch('plan/setSelectedPlan', planToSwitchTo);
            this.$store.dispatch('plan/setPlanType', planToSwitchTo.planType);
            this.trackAnnualToggleClick(planToSwitchTo, switchToAnnual);
        },

        trackAnnualToggleClick(plan, switchToAnnual) {
            let planTitle = plan.titleForTracking ?? '';

            if (Domain.isInternational()) {
                planTitle = plan.planTier ?? '';
            }

            const trackingParams = {
                pickPlanIsAnnual: switchToAnnual.toString(),
                pickPlanSku: plan.recurlyCode ?? '',
                pickPlanType: planTitle,
                productOfferPeriod: plan.trialString ?? '',
                productPricingPlan: plan.planType ?? '',
                purchasePrice: plan.rawPrice ?? '',
                purchaseProduct: plan.recurlyCode ?? '',
                purchaseProductName: planTitle ?? '',
                purchaseQuantity: '1',
            };

            if (this.isExSubscriber) {
                trackingParams.pageType = PAGE_TYPES.EXSUB_PAYMENT;
            } else {
                trackingParams.pageType = PAGE_TYPES.PAYMENT;
            }

            const trackingAction =
                this.isUpgradeAnnualToggle === true
                    ? ACTION_NAMES.PAYMENT_ANNUAL_PLAN_TOGGLE
                    : ACTION_NAMES.SELECT_NEW_BILLING_CADENCE;

            tracking.trackAction(trackingAction, trackingParams);
        },
    },
};
